import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import client from "../lib/api";
import * as Icons from "lucide-react";
import { Lock } from "lucide-react";

export default function Badges() {
    const [badges, setBadges] = useState([]);
    const [rewards, setRewards] = useState([]);

    useEffect(() => {
        client.get("/badges").then((r) => setBadges(r.data));
        client.get("/rewards").then((r) => setRewards(r.data));
    }, []);

    return (
        <div className="px-5 pt-8 pb-8">
            <span className="label-cap text-xs text-neon-orange">Badges & Rewards</span>
            <h1 className="font-display font-black text-4xl uppercase tracking-tight mt-1">Trophy Wall</h1>

            <h2 className="mt-6 font-display font-black text-xl uppercase tracking-tight">Badges</h2>
            <div className="grid grid-cols-3 gap-3 mt-3">
                {badges.map((b, i) => {
                    const Icon = Icons[b.icon] || Icons.Award;
                    return (
                        <motion.div
                            key={b.id}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: i * 0.04 }}
                            data-testid={`badge-${b.code}`}
                            className={`p-3 flex flex-col items-center text-center transition-all ${
                                b.earned ? "surface-2 glow-green" : "surface-1 opacity-50"
                            }`}
                        >
                            <div
                                className="w-14 h-14 flex items-center justify-center rounded-full"
                                style={{
                                    background: b.earned ? "#39FF1420" : "#262626",
                                    border: `1px solid ${b.earned ? "#39FF14" : "#333"}`,
                                }}
                            >
                                {b.earned ? (
                                    <Icon size={22} className="text-neon-green" />
                                ) : (
                                    <Lock size={18} className="text-zinc-500" />
                                )}
                            </div>
                            <div className="font-display font-bold uppercase text-[11px] tracking-tight mt-2 leading-tight">
                                {b.name}
                            </div>
                            <div className="text-[10px] text-zinc-500 mt-1 line-clamp-2">{b.description}</div>
                        </motion.div>
                    );
                })}
            </div>

            <h2 className="mt-8 font-display font-black text-xl uppercase tracking-tight">Rewards</h2>
            <div className="space-y-2 mt-3">
                {rewards.map((r) => (
                    <div
                        key={r.id}
                        data-testid={`reward-${r.id}`}
                        className={`surface-1 p-4 flex items-center gap-3 ${r.unlocked ? "" : "opacity-50"}`}
                    >
                        <div
                            className="w-10 h-10 flex items-center justify-center"
                            style={{
                                background: r.unlocked ? "#FF3B3020" : "#262626",
                                border: `1px solid ${r.unlocked ? "#FF3B30" : "#333"}`,
                            }}
                        >
                            {r.unlocked ? (
                                <Icons.Gift size={18} className="text-neon-orange" />
                            ) : (
                                <Lock size={16} className="text-zinc-500" />
                            )}
                        </div>
                        <div className="flex-1">
                            <div className="font-display font-bold uppercase text-sm leading-none">{r.title}</div>
                            <div className="text-xs text-zinc-500 mt-1">{r.description}</div>
                        </div>
                        <div className="text-right">
                            <div className="text-xs text-zinc-500 label-cap">Lv {r.level_required}</div>
                            <div className="text-xs text-neon-green label-cap mt-1">{r.xp_required} XP</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
